<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="pageIndex"
    :page-sizes="[10, 20, 30]"
    :page-size="pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="totalCount"
    :hide-on-single-page="isHidePage"
    class="pagination"
    background
  >
  </el-pagination>
</template>

<script>
export default {
  data() {
    return {
      isHidePage: false, // 只有一页时隐藏
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
    };
  },
  methods: {
    // 页容量发生改变
    handleSizeChange(val) {
      this.page = val;
      let obj = {
        pageSize: val,
        pageIndex: this.pageIndex,
      };
      // this.$store.dispatch('area/setPaginObj', obj);
      this.$emit('handleSizeChange', obj);
    },
    // 当前页发生改变
    handleCurrentChange(val) {
      let obj = {
        pageSize: this.pageSize,
        pageIndex: val,
      };
      this.$emit('handleCurrentChange', obj);
      // this.$store.dispatch('area/setPaginObj', obj);
    },
  },
};
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>
